module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Oberentfelden_AG-e50932d205048e2f354260fa022bb8d3.svg";